import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { CreditoLivreListagemComponent } from "./listagem/credito-livre-listagem/credito-livre-listagem.component";
import { RepasseListagemComponent } from "./listagem/repasse-listagem/repasse-listagem.component";
import { NaturezasJuridicasAceitasRoutingModule } from "./naturezas-juridicas-aceitas-routing.module";
import { NaturezasJuridicasAceitasPesquisaComponent } from "./pesquisa/naturezas-juridicas-aceitas-pesquisa.component";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";




@NgModule({
  imports: [ SharedModule,
            BrowserModule,
            CommonModule,
            NaturezasJuridicasAceitasRoutingModule, BnConfirmDirective],
  exports: [],
  declarations: [NaturezasJuridicasAceitasPesquisaComponent,
    RepasseListagemComponent,
    CreditoLivreListagemComponent
   ],
  providers: [],
  schemas: []
})
export class NaturezasJuridicasAceitasModule { }
